import api from 'services/api'
import {
  DECRYPT_EMAIL_SUCCESS,
  DECRYPT_EMAIL_ERROR,
} from './constants'

export const decryptEmailSuccess = response => ({
  type: DECRYPT_EMAIL_SUCCESS,
  response,
})

export const decryptEmailError = response => ({
  type: DECRYPT_EMAIL_ERROR,
  response,
})

export const decryptEmail = input => dispatch => api.request('decryptEmail', { input }).then((response) => {
  if (!response || response.errorCode === 'INTERNAL_ERROR') {
    return false
  } else if (response.status === 'ERROR') {
    return dispatch(decryptEmailError(response))
  }
  return dispatch(decryptEmailSuccess(response))
})
